import 'jquery-match-height'

export default {
    init() {
        //Quotes Slider
        $('[data-slider="quotes"]').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            prevArrow: '<i class="far fa-2x fa-chevron-left ll-cursor-pointer ll-text-white ll-z-20 ll-absolute ll-left-0 ll-top-1/2 ll-transform ll--translate-y-1/2"></i>',
            nextArrow: '<i class="far fa-2x fa-chevron-right ll-cursor-pointer ll-text-white ll-z-20 ll-absolute ll-right-0 ll-top-1/2 ll-transform ll--translate-y-1/2"></i>',
            accessibility: true,
            autoplay: true,
            autoplaySpeed: 10000,
        })

        $('.hvac-column__title').matchHeight({byRow:false});
    },
}


// WEBPACK FOOTER //
// ./scripts/routes/templateHvac.js